import React, { useState } from "react";
import { Box, Typography, Chip } from "@mui/material";
import ScaleRoundedIcon          from "@mui/icons-material/ScaleRounded";
import LocalShippingRoundedIcon  from "@mui/icons-material/LocalShippingRounded";
import LayersRoundedIcon         from "@mui/icons-material/LayersRounded";
import WeightTierTable    from "./WeightTierTable";
import HandlingTierTable  from "./HandlingTierTable";
import { PRC_BG, PRC_HEADER_GRADIENT } from "./_pricingTheme";

/**
 * PRC-001 — Pricing Tiers admin page.
 * Two registry-locked editors:
 *   1. Weight-tier multipliers  → syt_pricing_weight_tiers
 *   2. Handling-charge tiers    → syt_pricing_handling_tiers
 */
export default function PricingTiers() {
  const [tab, setTab] = useState(0);

  const TABS = [
    { label:"Weight-tier multipliers", icon:<ScaleRoundedIcon /> },
    { label:"Handling charges",        icon:<LocalShippingRoundedIcon /> },
  ];

  return (
    <Box sx={{ bgcolor: PRC_BG.page, minHeight:"100%" }}>

      {/* ── Gradient header banner ── */}
      <Box sx={{ background: PRC_HEADER_GRADIENT, color:"white", px:4, pt:3.5, pb:5, boxShadow:"0 8px 32px rgba(0,124,132,0.25)" }}>
        <Box sx={{ display:"flex", alignItems:"center", gap:1, mb:1.5 }}>
          <Box sx={{ width:46,height:46,borderRadius:"12px",bgcolor:"rgba(255,255,255,0.18)",border:"1px solid rgba(255,255,255,0.25)",display:"flex",alignItems:"center",justifyContent:"center" }}>
            <LayersRoundedIcon sx={{ fontSize:24,color:"#fff" }} />
          </Box>
          <Box sx={{ display:"flex", gap:0.75 }}>
            <Chip size="small" label="PRC-001" sx={{ bgcolor:"rgba(255,255,255,0.2)", color:"white", fontWeight:800, letterSpacing:0.6, fontSize:10, height:22, border:"1px solid rgba(255,255,255,0.3)" }} />
            <Chip size="small" label="ADMIN"   sx={{ bgcolor:"rgba(255,255,255,0.2)", color:"white", fontWeight:800, letterSpacing:0.6, fontSize:10, height:22, border:"1px solid rgba(255,255,255,0.3)" }} />
          </Box>
        </Box>
        <Typography sx={{ fontSize:26, fontWeight:800, letterSpacing:-0.5, lineHeight:1.1, mb:0.8, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
          Pricing Tiers
        </Typography>
        <Typography sx={{ fontSize:13, color:"rgba(255,255,255,0.85)", maxWidth:720, lineHeight:1.6, mb:2.5 }}>
          Tunable weight-tier multipliers and handling-charge bands used by the v2 pricing engine.
          Edits propagate to live customer quotes within seconds. Engine version cutover happens on the Billing Settings page.
        </Typography>

        {/* ── Pill tab toggle (inside gradient) ── */}
        <Box sx={{ display:"flex", gap:0.5, bgcolor:"rgba(255,255,255,0.12)", border:"1px solid rgba(255,255,255,0.22)", borderRadius:"14px", p:0.6, width:"fit-content" }}>
          {TABS.map((t, i) => (
            <Box key={i} onClick={() => setTab(i)} sx={{
              display:"flex", alignItems:"center", gap:0.8,
              px:2.2, py:1, borderRadius:"10px", cursor:"pointer",
              ...(tab===i
                ? { bgcolor:"rgba(255,255,255,0.22)", color:"#fff", border:"1px solid rgba(255,255,255,0.35)" }
                : { bgcolor:"transparent", color:"rgba(255,255,255,0.65)", border:"1px solid transparent" }),
              fontWeight: tab===i ? 700 : 500, fontSize:13, transition:"all 0.15s",
              fontFamily:"'Plus Jakarta Sans',sans-serif",
              "&:hover": tab!==i ? { bgcolor:"rgba(255,255,255,0.12)", color:"#fff" } : {},
            }}>
              {React.cloneElement(t.icon, { sx:{ fontSize:15 } })}
              {t.label}
            </Box>
          ))}
        </Box>
      </Box>

      {/* ── Content ── */}
      <Box sx={{ px:3, pt:3, pb:3, mt:-1, bgcolor:"white", borderTopLeftRadius:20, borderTopRightRadius:20,
        boxShadow:"0 -6px 24px -8px rgba(0,124,132,0.18)", minHeight:"calc(100vh - 240px)" }}>
        {tab === 0 && <WeightTierTable />}
        {tab === 1 && <HandlingTierTable />}
      </Box>
    </Box>
  );
}
